import { render, staticRenderFns } from "./SomenteClientes4Form.vue?vue&type=template&id=38318134&scoped=true&"
import script from "./SomenteClientes4Form.vue?vue&type=script&lang=js&"
export * from "./SomenteClientes4Form.vue?vue&type=script&lang=js&"
import style0 from "./SomenteClientes4Form.vue?vue&type=style&index=0&id=38318134&scoped=true&lang=css&"
import style1 from "./SomenteClientes4Form.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38318134",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VCard,VCardActions,VCol,VContainer,VIcon,VRow,VTooltip})
